import './style.scss';

import React from 'react';
import { Link } from 'react-router-dom';
import CartButton from 'components/cart/button';
import Login from './login';
import Search from 'components/search';
import Address from './address';
import HeaderNav from './nav';
import Banner from '../banner';
import SauceyLogo from 'images/saucey.svg';
import { AsyncAvailabilityModal } from 'components/async';

class HeaderComponent extends React.Component {
  render() {
    const { pageName, cartOpen, headerRef } = this.props;
    const className = 'nav-container';

    return (
      <div className={className}>
        <div
          className={'app-header' + (cartOpen ? ' app-header--cart-open' : '')}
          ref={headerRef}
        >
          <div id="header">
            <i className="icon-hamburger js-slideout-toggle" />
            <Link to="/" className="nav-logo">
              <img src={SauceyLogo} />
            </Link>
            <HeaderNav />
            <a className="become-a-courier" href="/apply">
              Become a Courier
            </a>
            <Login />
          </div>
          <nav id="nav-bar">
            <Search />
            <div id="nav-right">
              <Address trackingParams={{ page: pageName, source: 'Header' }} />
              <div className="nav-bar__cart-btn-container">
                <CartButton />
              </div>
            </div>
          </nav>
          <Banner />
          <AsyncAvailabilityModal />
        </div>
      </div>
    );
  }
}

export default HeaderComponent;



// WEBPACK FOOTER //
// ./shared/components/header/index.js